// Hack for reducing dependency on rx-anglar, to be replaced
// by something nicer - for example a dedicated rx operator
module.exports = function ($scope) {
  return function (callback) {
    return function (data) {
      $scope.$$phase || $scope.$root.$$phase
        ? callback(data)
        : $scope.$apply(() => {
            callback(data);
          });
    };
  };
};
